import { $color_brand_text_defalut, $color_brand_text_hover, $color_brand_text_active, $color_brand_text_disabled } from '../pebbleGlobalToken/color.js';

/**
 * Link组件-默认文字颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_defalut
 */
var $typography_link_text_color_default = $color_brand_text_defalut;

/**
 * Link组件-hover文字颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_hover
 */
var $typography_link_text_color_hover = $color_brand_text_hover;

/**
 * Link组件-激活态文字颜色。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_active
 */
var $typography_link_text_color_active = $color_brand_text_active;

/**
* Link组件-禁用态文字颜色。
* @description enDesc: -
* @description type: Color
* @description value: $color_brand_text_disabled
*/
var $typography_link_text_color_disabled = $color_brand_text_disabled;

export { $typography_link_text_color_active, $typography_link_text_color_default, $typography_link_text_color_disabled, $typography_link_text_color_hover };
